export function isMissingOrEmpty(value: any): boolean {
  return !value
    || ( typeof value === 'string' && value.trim().length === 0 )
    || ( Array.isArray(value) && value.length === 0 )
    || value.length === 0
  ;
}

export function isAnyMissingOrEmpty(values: any[]): boolean {
  return values.some( it => isMissingOrEmpty(it) );
}

/**
 * Vergleicht zwei Werte strukturell - erkennt Fake Changes (Objekt-Referenzwechsel ohne
 * inhaltlichen Unterschied).
 */
function normalizeForCompare(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map(normalizeForCompare);
  }
  if (value && typeof value === 'object') {
    const obj = value as Record<string, unknown>;
    return Object.keys(obj)
      .sort()
      .reduce((acc, key) => {
        acc[key] = normalizeForCompare(obj[key]);
        return acc;
      }, {} as Record<string, unknown>);
  }
  return value;
}

export function isDeepEqual(a: unknown, b: unknown): boolean {
  return JSON.stringify(normalizeForCompare(a)) === JSON.stringify(normalizeForCompare(b));
}

